export enum CANCEL_TYPE {
  CANCEL = 'CANCEL',
  PARTIAL_CANCEL = 'PARTIAL_CANCEL',
}

export enum VALIDATE_STATUS_TRADE {
  OKAY = '결제하기',
  CANCEL = '취소',
  INPUT = '구매 수량을 입력해주세요',
  COUNT = '남은 조각 수량을 초과했어요',
  SIGN_IN = '로그인을 해주세요!',
  BALANCE = '예치금이 부족해요',
  LIMIT_COUNT = '구매 가능 수량을 초과했습니다.',
  OWN_COUNT = '보유 수량을 초과했습니다.',
  BANK_INSPECTION = '은행 점검 시간입니다.',
  ACTIVE_PRODUCT_SALE = '구매계약 일반 조건을 체크해 주세요',
  PURCHSE_CONTRACT = '구매 계약서를 체크해 주세요',
  TERMS = '필수 약관을 체크해주세요.',
  FORMAT = '입력 형식에 맞지않습니다.',
}

export const SUBSCRIPTION_VALIDATE_MESSAGE = {
  OKAY: '결제하기',
  INPUT: '청약 신청 수량을 입력해 주세요',
  OVER_AMOUNT: '최대 신청 가능 금액을 초과했어요',
  BALANCE: '예치금이 부족해요',
  TERMS: '필수 조건에 동의 해주세요',
} as const

export const SUBSCRIPTION_VALIDATE = {
  OKAY: 'OKAY',
  INPUT: 'INPUT',
  OVER_AMOUNT: 'OVER_AMOUNT',
  BALANCE: 'BALANCE',
  TERMS: 'TERMS',
} as const

type SUBSCRIPTION_VALIDATE_TYPE = typeof SUBSCRIPTION_VALIDATE

type SUBSCRIPTION_VALIDATE_KEY_TYPES = keyof SUBSCRIPTION_VALIDATE_TYPE

export enum VALIDATE_STATUS {
  OKAY,
  INPUT,
  CHECK,
}

export enum LOADING_STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  FAILED = 'FAILED',
  LOADED = 'LOADED',
  NOT_FOUND = 'NOT_FOUND',
}

export const API_STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  FAILED: 'FAILED',
  LOADED: 'LOADED',
  NOT_FOUND: 'NOT_FOUND',
}

export const PAGE_NAME = {
  SIGN_UP: 'SIGNUP',
  SETTLEMENT: 'SETTLEMENT',
  PURCHASE: 'PURCHASE',
  TRADE_BUY: 'TRADE_BUY',
  TRADE_SELL: 'TRADE_SELL',
  REFUND: 'REFUND',
  DEPOSIT_ACCOUNT: 'DEPOSIT_ACCOUNT',
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  UNREGISTER: 'UNREGISTER',
} as const

export const PAGES = {
  SIGN_UP: 'SIGNUP',
  SIGNUP_MKT_SMS: 'SIGNUP_MKT_SMS',
  SIGNUP_MKT_EMAIL: 'SIGNUP_MKT_EMAIL',
  SETTLEMENT: 'SETTLEMENT',
  PURCHASE: 'PURCHASE',
  TRADE_BUY: 'TRADE_BUY',
  TRADE_SELL: 'TRADE_SELL',
  REFUND: 'REFUND',
  WITHDRAWAL_ACCOUNT: 'WITHDRAWAL_ACCOUNT',
  DEPOSIT_ACCOUNT: 'DEPOSIT_ACCOUNT',
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  UNREGISTER: 'UNREGISTER',
}

export type { SUBSCRIPTION_VALIDATE_TYPE, SUBSCRIPTION_VALIDATE_KEY_TYPES }
